import React from 'react'
import { GoogleMap, useJsApiLoader, Marker, MarkerClusterer } from '@react-google-maps/api';
import nafilPin from '../../assets/img/NAFIL_Pin.svg';
import api from '../../services/api';
import { Grid, Paper, Card, Input } from '@mui/material';
import Mapas_Detalhes from '../Mapas_Detalhes/Mapas_Detalhes';
import { useEffect, useState, useCallback, memo } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';

const containerStyle = {
  width: '100%',
  height: '450px'
};

function MyComponent(props) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyBelgutdOpk7xXr4XYzJO5MfohIZtgzCw8"
  })

  const [feito, setFeito] = useState(false);
  const [posicao, setPosicao] = useState([]);
  const [mapaCarregado, setMapaCarregado] = useState(false);
  const [filialClicada, setFilialClicada] = useState({});
  const [mapXY, setMapXY] = useState({})
  const [centerXY, setCenterXY] = useState({});
  var maps = null;

  function RefazerMakers(map) {
    posicao.map((fil, index) => {
      var marker = new window.google.maps.Marker({        
        position: { lat: Number(fil.latitude), lng: Number(fil.longitude) },
        icon: nafilPin,
        // coordinates,
        map: map,
        animation: 1,
        label: { fontSize: '20px', text: `${fil.filial}`, className: "map-maker" }
      });
      window.google.maps.event.addListener(marker, 'click', function() {Detalhes_Filial(fil.filial)});
    });
  }


  function Reposicionar(e) {
    const found = posicao.find(element => element.filial == e.currentTarget.id.replace(/\D/g, ""));
    if (found != null) {
      setCenterXY({ lat: Number(found.latitude), lng: Number(found.longitude) });
      var myOptions = {
        center: { lat: Number(found.latitude), lng: Number(found.longitude) },
        zoom: 15, styles: [{
          elementType: "labels",
          featureType: "poi",
          stylers: [{ visibility: "off" }]
        }]
      };
      var map = new window.google.maps.Map(document.getElementById("Google_MAPS"), myOptions);
      RefazerMakers(map)
    }
  }

  function AplicarMapa() {
    maps = <GoogleMap
      id="Google_MAPS"
      key="Google_MAPS"
      mapContainerStyle={containerStyle}
      center={centerXY}
      // onLoad={onLoad}
      // onUnmount={onUnmount}                   
      options={{
        zoom: 9, styles: [{
          elementType: "labels",
          featureType: "poi",
          stylers: [{ visibility: "off" }]
        }]
      }}
    >
      {
        posicao.map((fil, index) => {
          return (<div>
            <Marker id={fil.filial} key={fil.filial} icon={nafilPin}
              onClick={() => Detalhes_Filial(fil.filial)}
              animation={window.google.maps.Animation.BOUNCE} position={{ lat: Number(fil.latitude), lng: Number(fil.longitude) }} options={{
                label: { fontSize: '20px', text: `${fil.filial}`, className: "map-maker" }
              }}
            />
          </div>);
        })
      }
      {/* <Marker icon={nafilPin} position={{ lat: -22.49987, lng: -44.10758 }} options={{ label: { text: "MATRIZ", className: "map-maker" } }} />
          <Marker icon={nafilPin} position={{ lat: -22.500342239319213, lng: -44.10859648850328 }} options={{ label: { text: "Minha Loja", className: "map-maker" } }} /> */}
    </GoogleMap>
    return (
      maps
    );
  }

  function BuscarFiliais(filial = 0) {
    api.get(`Clientes/ClienteFiliais/${filial}`)
      .then(CheckError)
      .then((response) => {
        return response;
      })
      .then((data) => {
        setPosicao(data.data);
        setMapaCarregado(true);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  function CheckError(response) {
    if (response.status >= 200 && response.status <= 299) {
      return response;
    } else {
      console.log(response.statusText);
    }
  }

  useEffect(() => {
    if (!feito) {
      BuscarFiliais(0);
      setCenterXY({
        lat: -22.49987073452251,
        lng: -44.10758362314015
      });
    }
    setFeito(true);
  }, []);


  const onLoad = useCallback(function callback(map) {
    // var map = new window.google.maps.Map(document.getElementById("Google_MAPS"));
    // const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);
    //setMapXY(map);
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMapXY(null)
  }, [])

  function Detalhes_Filial(loja) {
    document.getElementById('Filial_' + loja).scrollIntoView();
  }

  return isLoaded && mapaCarregado ? (
    <>
    <BrowserView>
    <div id="Geral" key="Geral">
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item xs={2.5} sx={{ overflowY: "scroll", maxHeight: "450px" }}>
          <div id="Lojas_Relacoes" key="Lojas_Relacoes" >
            <Mapas_Detalhes posicao={posicao} props={props} filialClicada={Reposicionar.bind(this)} id={"RELACAO_FILIAIS"} />
          </div>
        </Grid>

        <Grid item xs={9.5}>
          <div id="Mapa_Renderizado_" key="Mapa_Renderizado_" className='Mapas'>
            {AplicarMapa()}
          </div>
        </Grid>
      </Grid>
    </div>
    </BrowserView>


    <MobileView>
    <div id="Geral" key="Geral">
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item xs={12}>
          <div id="Mapa_Renderizado_" key="Mapa_Renderizado_" className='Mapas'>
            {AplicarMapa()}
          </div>
        </Grid>

        <Grid item xs={12} sx={{ overflowY: "scroll", maxHeight: "450px" }}>
          <div id="Lojas_Relacoes" key="Lojas_Relacoes" >
            <Mapas_Detalhes posicao={posicao} props={props} filialClicada={Reposicionar.bind(this)} id={"RELACAO_FILIAIS"} />
          </div>
        </Grid>        
      </Grid>
    </div>
    </MobileView>

    </>

  ) : <div id="Sem_Mapa" key="Sem_Mapa"></div>
}
export default memo(MyComponent)
